import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import MDButton from 'components/MDButton';
import 'react-dropdown/style.css';
// import MDInput from "components/MDInput";
import React, { useState, useEffect } from "react";
import { Oval } from 'react-loader-spinner';
import Table from '@mui/material/Table';
// import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Select from 'react-select';
import ReactHTMLTableToExcel from 'react-html-table-to-excel';
import * as moment from 'moment';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
// import { jsPDF } from 'jspdf';
// import html2canvas from "html2canvas";
import * as service from '../../services/service';

function MaterialIssueReport() {
    const [reportDetailsData, setReportDetailsData] = useState([]);
    const [showDetailsReport, setShowDetailsReport] = useState(false);
    // const [materialCategoryData, setMaterialCategoryData] = useState([]);
    // const [materialSubCategoryData, setMaterialSubCategoryData] = useState([]);
    // const [materialData, setMaterialData] = useState([]);
    // const [materialCategoryId, setMaterialCategoryId] = useState('');
    // const [materialSubCategoryId, setMaterialSubCategoryId] = useState('');
    // const [materialId, setMaterialId] = useState('');
    const [employeeData, setEmployeeData] = useState([]);
    const [employeeId, setEmployeeId] = useState('');
    const [fromDate, setFromDate] = useState(null);
    const [toDate, setToDate] = useState(null);
    const [errors, setErrors] = useState({});
    const [loading, setLoading] = useState(false);
    const selectStyles = { menu: styles => ({ ...styles, zIndex: 999 }) };
    const userDesignation = JSON.parse(sessionStorage.getItem('userData')).designation;
    const getEmployee = () => {
        fetch(
            service.EMPLOYEE_URL,
            {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
            })
            .then(res => res.json())
            .then(result => {
                const data2 = result.map((item) => ({ value: item.employeeId, label: item.employeeName }));

                const all = ({ value: "0", label: "All" });
                data2.unshift(all);
                setEmployeeData(data2);
                setEmployeeId(all);
            });
    };
    // const getMaterialCategories = () => {
    //     fetch(
    //         service.MATERIAL_CATEGORY_URL,
    //         {
    //             method: 'POST',
    //             headers: {
    //                 'Accept': 'application/json',
    //                 'Content-Type': 'application/json'
    //             },
    //         })
    //         .then(res => res.json())
    //         .then(result => {
    //             const data2 = result.map((item) => ({ value: item.materialCategoryId, label: item.materialCategory }));
    //             const all = ({ value: "0", label: "All" });
    //             data2.unshift(all);
    //             setMaterialCategoryData(data2);
    //             setMaterialCategoryId(all);
    //         });
    // };
    // const getMaterialSubCategories = (id) => {
    //     fetch(
    //         service.MATERIAL_SUB_CATEGORY_URL,
    //         {
    //             method: 'POST',
    //             headers: {
    //                 'Accept': 'application/json',
    //                 'Content-Type': 'application/json'
    //             },
    //             body: JSON.stringify({
    //                 materialCategoryId: id,
    //             })
    //         })
    //         .then(res => res.json())
    //         .then(result => {
    //             const data2 = result.map((item) => ({ value: item.materialSubCategoryId, label: item.materialSubCategory }));
    //             const all = ({ value: "0", label: "All" });
    //             data2.unshift(all);
    //             setMaterialSubCategoryData(data2);
    //             setMaterialSubCategoryId(all);
    //         });
    // };
    // const getMaterials = (id) => {
    //     fetch(
    //         service.MATERIAL_URL,
    //         {
    //             method: 'POST',
    //             headers: {
    //                 'Accept': 'application/json',
    //                 'Content-Type': 'application/json'
    //             },
    //             body: JSON.stringify({
    //                 materialCategoryId: materialCategoryId.value,
    //                 materialSubCategoryId: id
    //             })
    //         })
    //         .then(res => res.json())
    //         .then(result => {
    //             const data2 = result.map((item) => ({ value: item.materialId, label: item.material }));
    //             const all = ({ value: "0", label: "All" });
    //             data2.unshift(all);
    //             setMaterialData(data2);
    //             setMaterialId(all);
    //         });
    // };

    function GetReport() {
        const errs = {};
        fetch(
            service.GET_MATERIAL_ISSUE_REPORT,
            {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    // MaterialId: materialId ? materialId.value : 0,
                    IssuedTo: employeeId ? employeeId.value : 0,
                    FromDate: fromDate ? moment(fromDate).format("MM/DD/YYYY") : null,
                    ToDate: toDate ? moment(toDate).format("MM/DD/YYYY") : null
                })
            })
            .then(res => res.json())
            .then(result => {
                if (result.length === 0) {
                    errs[".invalid"] = 'No Data Found!';
                    setErrors(errs);
                    setShowDetailsReport(false);
                    setReportDetailsData([]);
                }
                else if (result.length > 0 && result[0].message.messageType === 'Success') {
                    setShowDetailsReport(true);
                    setReportDetailsData(result);
                    errs[".invalid"] = '';
                    setErrors(errs);
                }
                else if (result[0].message.messageType === 'Failed') {
                    errs[".invalid"] = result[0].message.message;
                    setErrors(errs);
                    setShowDetailsReport(false);
                    setReportDetailsData([]);
                }
                else {
                    errs[".invalid"] = result[0].message.message;
                    setErrors(errs);
                    setShowDetailsReport(false);
                    setReportDetailsData([]);
                }
            });
    }

    useEffect(() => {
        setLoading(true);
        // getMaterialCategories();
        getEmployee();
        setLoading(false);
    }, []);

    const changeHandler = (ev) => {
        setEmployeeId(ev);
    }

    // const materialCategoryChangeHandler = (ev) => {
    //     setMaterialCategoryId(ev);
    //     setMaterialSubCategoryId(null);
    //     setMaterialId(null);
    //     getMaterialSubCategories(ev.value);
    //     setReportDetailsData([]);
    // }
    // const materialSubCategoryChangeHandler = (ev) => {
    //     setMaterialSubCategoryId(ev);
    //     setMaterialId(null);
    //     getMaterials(ev.value);
    //     setReportDetailsData([]);
    // }
    // const materialChangeHandler = (ev) => {
    //     setMaterialId(ev);
    //     setReportDetailsData([]);
    // }

    const submitHandler = e => {
        setShowDetailsReport(false);
        e.preventDefault();
        setLoading(true);
        GetReport();
        setLoading(false);
    }
    return (
        <DashboardLayout>
            <DashboardNavbar />
            <MDBox pt={6} pb={3}>
                <Grid container spacing={6}>
                    <Grid item xs={12}>
                        {userDesignation === 'General Manager' || userDesignation === 'Asst Mgr - Store'
                            || userDesignation === 'Jr Mgr - Store' || userDesignation === 'Manager - Store'
                            || userDesignation === 'Sr Mgr - Store' || userDesignation === 'Asst Mgr - Production'
                            || userDesignation === 'Jr Mgr - Production' || userDesignation === 'Manager - Production'
                            || userDesignation === 'Sr Mgr - Production' || userDesignation === 'MD'
                            || userDesignation === 'Bussiness Development and Operations' || userDesignation === 'Assistant - Store' 
                            || userDesignation === 'Jr Mgr - Purchase' || userDesignation === 'Manager - Purchase'
                            || userDesignation === 'Sr Mgr - Purchase' ?
                            <Card>
                                <MDBox
                                    mx={2}
                                    mt={-3}
                                    py={3}
                                    px={2}
                                    variant="gradient"
                                    bgColor="info"
                                    borderRadius="lg"
                                    coloredShadow="info"
                                >
                                    <MDTypography variant="h6" color="white">
                                        Material Issue Report
                                    </MDTypography>
                                </MDBox>
                                <br />
                                <Table aria-label="simple table">
                                    {/* <TableRow>
                                        <TableCell width="15%" align="right" style={{ fontSize: '12px' }}>
                                            Material Category :
                                        </TableCell>
                                        <TableCell width="20%" style={{ fontSize: '12px' }}>
                                            <Select
                                                options={materialCategoryData}
                                                name="materialCategory"
                                                value={materialCategoryId}
                                                onChange={materialCategoryChangeHandler}
                                                placeholder="Select Material Category"
                                                isSearchable
                                                styles={selectStyles}
                                            />
                                        </TableCell>
                                        <TableCell width="15%" align="right" style={{ fontSize: '12px' }}>
                                            Material Sub Category :
                                        </TableCell>
                                        <TableCell width="20%" style={{ fontSize: '12px' }}>
                                            <Select
                                                options={materialSubCategoryData}
                                                name="materialSubCategory"
                                                value={materialSubCategoryId}
                                                onChange={materialSubCategoryChangeHandler}
                                                placeholder="Select Material Sub Category"
                                                isSearchable
                                                styles={selectStyles}
                                            />
                                        </TableCell>
                                        <TableCell width="10%" align="right" style={{ fontSize: '12px' }}>
                                            Material :
                                        </TableCell>
                                        <TableCell style={{ fontSize: '12px' }}>
                                            <Select
                                                options={materialData}
                                                name="material"
                                                value={materialId}
                                                onChange={materialChangeHandler}
                                                placeholder="Select Material"
                                                isSearchable
                                                styles={selectStyles}
                                            />
                                        </TableCell>
                                    </TableRow> */}
                                    <TableRow>
                                        <TableCell align="right" style={{ fontSize: '12px' }}>
                                            Employee :
                                        </TableCell>
                                        <TableCell style={{ fontSize: '12px' }}>
                                            <Select
                                                options={employeeData}
                                                name="employee"
                                                value={employeeId}
                                                onChange={changeHandler}
                                                placeholder="Select Employee"
                                                isSearchable
                                                styles={selectStyles}
                                            />
                                        </TableCell>
                                        <TableCell align="right" style={{ fontSize: '12px' }}>
                                            From Date :
                                        </TableCell>
                                        <TableCell style={{ fontSize: '12px' }}>
                                            <DatePicker
                                                id="fromDate"
                                                selected={fromDate}
                                                onChange={date => setFromDate(date)}
                                                dateFormat="MM/dd/yyyy"
                                            />
                                        </TableCell>
                                        <TableCell align="right" style={{ fontSize: '12px' }}>
                                            To Date :
                                        </TableCell>
                                        <TableCell style={{ fontSize: '12px' }}>
                                            <DatePicker
                                                id="toDate"
                                                selected={toDate}
                                                onChange={date => setToDate(date)}
                                                dateFormat="MM/dd/yyyy"
                                            />
                                        </TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell colSpan="6" align="center">
                                            <MDBox mt={4} mb={1} textAlign="center">
                                                {loading ?
                                                    <Oval
                                                        heigth="20"
                                                        width="20"
                                                        color='grey'
                                                        ariaLabel='loading'
                                                    />

                                                    :
                                                    <MDButton color="info" onClick={submitHandler}>
                                                        Show
                                                    </MDButton>
                                                }
                                                {errors ? <div style={{ fontSize: '12px', color: 'red' }}>{errors[".invalid"]}</div> : null}
                                            </MDBox>
                                        </TableCell>
                                    </TableRow>
                                </Table>
                                <Card style={{ alignItems: 'center' }}>
                                    {loading ?
                                        <Oval
                                            heigth="100"
                                            width="100"
                                            color='grey'
                                            ariaLabel='loading'
                                        /> :
                                        <TableContainer component={Paper} style={{ width: '98%', alignSelf: 'center' }}>
                                            <Table id="dvDetailReport">
                                                <TableRow>
                                                    <TableCell colSpan="6" align="center">
                                                        <Table>
                                                            {/* <TableCell align="center" style={{ fontWeight: 'bold', fontSize: '14px' }}>
                                                                Material : {materialId ? materialId.label : 'All'}
                                                            </TableCell> */}
                                                            <TableCell align="center" style={{ fontWeight: 'bold', fontSize: '14px' }}>
                                                                Issued To : {employeeId ? employeeId.label : 'All'}
                                                            </TableCell>
                                                            <TableCell align="center" style={{ fontWeight: 'bold', fontSize: '14px' }}>
                                                                From Date : {fromDate ? moment(fromDate).format("DD/MM/YYYY") : ''}
                                                            </TableCell>
                                                            <TableCell align="center" style={{ fontWeight: 'bold', fontSize: '14px' }}>
                                                                To Date : {toDate ? moment(toDate).format("DD/MM/YYYY") : ''}
                                                            </TableCell>
                                                        </Table>
                                                    </TableCell>
                                                </TableRow>
                                                <TableRow style={{ backgroundColor: 'lightgrey' }}>
                                                    <TableCell width="10%" style={{ fontWeight: 'bold', fontSize: '14px' }}>Material Category</TableCell>
                                                    <TableCell width="10%" style={{ fontWeight: 'bold', fontSize: '14px' }}>Material Sub Category</TableCell>
                                                    <TableCell width="20%" style={{ fontWeight: 'bold', fontSize: '14px' }}>Material</TableCell>
                                                    <TableCell width="10%" style={{ fontWeight: 'bold', fontSize: '14px' }}>Issued To</TableCell>
                                                    <TableCell width="10%" style={{ fontWeight: 'bold', fontSize: '14px' }}>Issued Date</TableCell>
                                                    <TableCell width="10%" style={{ fontWeight: 'bold', fontSize: '14px' }}>Issued Quantity</TableCell>
                                                    <TableCell width="10%" style={{ fontWeight: 'bold', fontSize: '14px' }}>Rate</TableCell>
                                                    <TableCell width="10%" style={{ fontWeight: 'bold', fontSize: '14px' }}>Amount</TableCell>
                                                    <TableCell style={{ fontWeight: 'bold', fontSize: '14px' }}>Remarks</TableCell>
                                                </TableRow>
                                                {reportDetailsData.map((row) => (
                                                    <TableRow
                                                        key={row.materialId}
                                                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                                    >
                                                        <TableCell style={{ fontSize: '14px' }}>{row.materialCategory}</TableCell>
                                                        <TableCell style={{ fontSize: '14px' }}>{row.materialSubCategory}</TableCell>
                                                        <TableCell style={{ fontSize: '14px' }}>{row.material}</TableCell>
                                                        <TableCell style={{ fontSize: '14px' }}>{row.issuedToName}</TableCell>
                                                        <TableCell style={{ fontSize: '14px' }}>{moment(row.issuedDate).format("DD/MM/YYYY")}</TableCell>
                                                        <TableCell style={{ fontSize: '14px' }}>{row.issuedQuantity}</TableCell>
                                                        <TableCell style={{ fontSize: '14px' }}>{row.rate}</TableCell>
                                                        <TableCell style={{ fontSize: '14px' }}>{row.issuedAmount}</TableCell>
                                                        <TableCell style={{ fontSize: '14px' }}>{row.remarks}</TableCell>
                                                    </TableRow>
                                                ))}
                                            </Table>
                                            <br />
                                            <Table>
                                                <TableRow>
                                                    <TableCell align="center">
                                                        {showDetailsReport ?
                                                            <ReactHTMLTableToExcel table="dvDetailReport" className="info"
                                                                filename="ReportData" sheet="Sheet" buttonText="EXPORT TO EXCEL"
                                                            />
                                                            : null}
                                                    </TableCell>
                                                </TableRow>
                                            </Table>
                                        </TableContainer>
                                    }
                                </Card>
                            </Card>
                            :
                            <Card style={{ alignItems: 'center' }}>
                                <div style={{ fontWeight: 'bold', fontSize: '14px', color: 'red' }}>You do not have access to this page</div>
                            </Card>
                        }
                    </Grid>
                </Grid>
            </MDBox>
            <Footer />
        </DashboardLayout>
    );
}

export default MaterialIssueReport;
